(() => {
  const nav = document.querySelector('[data-zo-nav]');
  if (!nav || nav.dataset.ready) return;
  nav.dataset.ready = '1';

  const onScroll = () => nav.classList.toggle('is-scrolled', window.scrollY > 4);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const items = nav.querySelectorAll('.zo-nav__item--drop');
  const closeAll = (except) => items.forEach((i) => {
    if (i === except) return;
    i.classList.remove('is-open');
    i.querySelector('button').setAttribute('aria-expanded', 'false');
  });
  items.forEach((item) => {
    const btn = item.querySelector('button');
    let t;
    const open = () => { clearTimeout(t); closeAll(item); item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); };
    const close = () => { t = setTimeout(() => { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }, 120); };
    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    btn.addEventListener('click', () => (item.classList.contains('is-open') ? close() : open()));
  });
  document.addEventListener('click', (e) => { if (!nav.contains(e.target)) closeAll(); });

  const search = nav.querySelector('[data-zo-search]');
  const menu = nav.querySelector('[data-zo-menu]');
  const burger = nav.querySelector('[data-zo-menu-open]');
  const setMenu = (open) => {
    menu.hidden = !open;
    burger.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('zo-lock', open);
  };
  nav.querySelector('[data-zo-search-open]').addEventListener('click', () => {
    setMenu(false);
    search.hidden = !search.hidden;
    if (!search.hidden) search.querySelector('input[type="search"]').focus();
  });
  nav.querySelector('[data-zo-search-close]').addEventListener('click', () => { search.hidden = true; });
  burger.addEventListener('click', () => { search.hidden = true; setMenu(menu.hidden); });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    search.hidden = true;
    setMenu(false);
    closeAll();
  });
})();

(() => {
  document.querySelectorAll('.product__description .accordion-button').forEach((b) => {
    const t = b.textContent.trim();
    if (t && t === t.toUpperCase()) b.textContent = t.charAt(0) + t.slice(1).toLowerCase();
  });
})();

(() => {
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-zo-buynow]');
    if (!btn) return;
    const form = btn.closest('form');
    if (!form.reportValidity()) return;
    btn.disabled = true;
    try {
      const res = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!res.ok) throw new Error();
      window.location.href = '/checkout';
    } catch (err) {
      btn.disabled = false;
      form.requestSubmit();
    }
  });
})();
